﻿
;
window.SetUpNavToggles = function () {

	var toggles = document.querySelectorAll('#MainNavigation .nav-expander');

	var expandedClassName = 'expanded';

	function toggleSection(el) {

		// find the parent list element and toggle a css class
		var li = el.parentElement;

		if (li != null) {
			if (li.classList.contains(expandedClassName)) {
				// expanded so collapse...

				li.classList.remove(expandedClassName);

			} else {
				// collapsed so expand...
				li.classList.add(expandedClassName);
			}
		}
	}

	for (var i = 0; i < toggles.length; i++) {
		toggles[i].addEventListener('click', function () {
			toggleSection(this);
		});
	}

};

if (document.readyState !== 'loading') {
	window.SetUpNavToggles();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpNavToggles();
	});
}